import { Checkbox, Dropdown, MenuProps, Space, Table, TableColumnsType, Tag } from 'antd';
import { ColumnsType } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { getAuthenticationURL, getBeneficiariesFromQuickBooksOnline, getVendorBillsFromQuickBooksOnline, importQuickBooksBeneficiaries, importQuickBooksVendorBills } from "../../api/NetworkingTools";
import AppContext from '../../App.context';
import { getResource } from "../../helpers/ResourcesHelper";
import Button from "../inputs/Button";
import { QBBeneBill, QBBillDetail } from "../models/QBBeneBill";
import { QBBeneficiary } from "../models/QBBeneficiary";


//for table

const qbBeneColumns: ColumnsType<QBBeneficiary> = [
  {
    title: 'Beneficiary ID',
    dataIndex: 'BeneficiaryID',
    render: (_, { BeneficiaryID }) => (
      BeneficiaryID > 0 ? <Tag color={'green'} key={BeneficiaryID}>
        {BeneficiaryID}
      </Tag> : BeneficiaryID
    ),
    sorter: (a, b) => Number(b.BeneficiaryID) - Number(a.BeneficiaryID)
    , align: 'center'
  },
  {
    title: 'Name',
    dataIndex: 'BeneficiaryName',
    width: '25%',
    sorter: (a, b) => (b.BeneficiaryName || '').localeCompare(a.BeneficiaryName),
    align: 'center'
  },
  {
    title: 'Type',
    dataIndex: 'BeneficiaryType'
  },
  {
    title: 'Contact Name',
    dataIndex: 'ContactName',
  },
  {
    title: 'Contact Phone',
    dataIndex: 'ContactPhone',
  },
  {
    title: 'Contact Email',
    dataIndex: 'ContactEmail',
  },
  {
    title: 'Address',
    dataIndex: 'AddressLine1',
  },
  {
    title: 'City',
    dataIndex: 'City',
  },
  {
    title: 'Country',
    dataIndex: 'Country',
  },
  {
    title: 'State',
    dataIndex: 'CountrySubDivisionCode',
  },
  {
    title: 'Currency',
    dataIndex: 'CurrencyRef',
  },
];

const qbBeneBillsColumns: ColumnsType<QBBeneBill> = [
  {
    title: 'Invoice ID',
    dataIndex: 'InvoiceIssuedId',
    render: (_, { InvoiceIssuedId }) => (
      InvoiceIssuedId > 0 ? <Tag color={'green'} key={InvoiceIssuedId}>
        {InvoiceIssuedId}
      </Tag> : InvoiceIssuedId
    )
    , sorter: (a, b) => Number(b.InvoiceIssuedId) - Number(a.InvoiceIssuedId)
    , align: 'center'
  },
  {
    title: 'Vendor',
    dataIndex: 'ExternalCustomerName',
    width: '25%',
    sorter: (a, b) => (b.ExternalCustomerName || '').localeCompare(a.ExternalCustomerName),
    align: 'center'
  },
  {
    title: 'Beneficiary ID',
    dataIndex: 'BeneficiaryID'
  },
  {
    title: 'Date',
    dataIndex: 'TxnDate'
  },
  {
    title: 'Due Date',
    dataIndex: 'DueDate'
  },
  {
    title: 'Amount',
    dataIndex: 'Amount'
  },
  {
    title: 'Currency',
    dataIndex: 'CurrencyId'
  }
  ,
  {
    title: 'QB Ref',
    dataIndex: 'Id'
  }
];


const QBActions = (params: any) => {

  const { showModal } = useContext(AppContext);
  const { showLoadingModal, hideLoadingModal } = useContext(AppContext);

  const [actionSelected, setActionSelected] = useState('')
  const [benes, setBenes] = useState([])
  const [beneBills, setBeneBills] = useState([])
  const [beneBillsDS, setBeneBillsDS] = useState([])
  const [modalInfo, setModalInfo] = useState({ title: '', message: '' })
  const [selectedBenes, setSelectedBenes] = useState<QBBeneficiary[]>([])
  const [selectedBeneBills, setSelectedBeneBills] = useState<QBBeneBill[]>([])
  const [payBills, setPayBills] = useState(false)

  useEffect(() => {
    if (modalInfo.message === '') {
      return;
    }
    showModal(modalInfo.title, modalInfo.message);
    setModalInfo(state => ({ ...state, title: '', message: '' }))
  }, [modalInfo, showModal]);

  useEffect(() => {
    setBeneBillsDS(beneBills.filter((b: QBBeneBill) => (payBills && b.InvoiceIssuedId > 0) || (!payBills && b.InvoiceIssuedId === 0)))
  }, [payBills, beneBills]);

  const getVendors = (authToken: string) => {
    const load = async () => {
      let benes = []
      let userSession = JSON.parse(localStorage.getItem('UserSession')!);
      let refreshToken = sessionStorage.getItem('QuickBooksRefresToken') || ''

      showLoadingModal()
      let response = await getBeneficiariesFromQuickBooksOnline(userSession.CustomerID, authToken, refreshToken)
      hideLoadingModal()      
      if (response.httpStatusCode === 200 && response.ErrorMessage === '') {
        sessionStorage.setItem('QuickBooksRefresToken', response.RefreshToken || '')
        benes = response.Beneficiaries;
        benes.forEach((element: QBBeneficiary) => {
          element.key = element.Id
        });
      }
      else if (response.ErrorMessage !== '') {
        setModalInfo(state => ({ ...state, title: getResource('Js_MessageError_TitleSubmit'), message: getResource('InternalServerError') + response.ErrorMessage }))
      }
      setBenes(benes)
    }
    load()
  }

  const getVendorBills = (authToken: string) => {
    const load = async () => {
      let refreshToken = sessionStorage.getItem('QuickBooksRefresToken') || ''
      let userSession = JSON.parse(localStorage.getItem('UserSession')!);

      showLoadingModal()
      let response = await getVendorBillsFromQuickBooksOnline(userSession.CustomerID, authToken, refreshToken, [])
      hideLoadingModal()      
      let vendorBills = []
      if (response.httpStatusCode === 200 && response.ErrorMessage === '') {
        sessionStorage.setItem('QuickBooksRefresToken', response.RefreshToken || '')
        vendorBills = response.VendorBills
        vendorBills.forEach((element: QBBeneBill) => {
          element.key = element.Id
        });
      }
      else if (response.ErrorMessage !== '') {
        setModalInfo(state => ({ ...state, title: getResource('Js_MessageError_TitleSubmit'), message: getResource('InternalServerError') + response.ErrorMessage }))
      }
      setBeneBills(vendorBills)
    }
    load()
  }

  const importQBenes = () => {
    const callImport = async () => {
      let userSession = JSON.parse(localStorage.getItem('UserSession')!);

      let response = await importQuickBooksBeneficiaries(selectedBenes, userSession.CustomerID, userSession.PersonID);
      console.log('importQBenes ', response)
      response.ErrorMessage = response.ErrorMessage || ''
      if (response.httpStatusCode === 200 && response.ErrorMessage === '') {
        setModalInfo(state => ({
          ...state, title: getResource('Js_MessageError_TitleSuccess'),
          message: response.Results
        }))
        getVendors(localStorage.getItem('QuickBooksAuthorizationCode') || '')
      }
      else if ([401, 403].includes(response.httpStatusCode) && response.Message !== '') {
        setModalInfo(state => ({
          ...state, title: getResource('Js_MessageError_TitleSubmit'),
          message: response.Message
        }))
      }
      else {
        setModalInfo(state => ({
          ...state, title: getResource('Js_MessageError_TitleSubmit'),
          message: getResource('SomethingWentWrong')
        }))
      }
    }
    callImport();
  }

  const importQVendorBills = () => {
    const callImport = async () => {
      let userSession = JSON.parse(localStorage.getItem('UserSession')!);

      let response = await importQuickBooksVendorBills(selectedBeneBills, userSession.CustomerID, userSession.PersonID);
      console.log('importQVendorBills ', response)
      response.ErrorMessage = response.ErrorMessage || ''
      if (response.httpStatusCode === 200 && response.ErrorMessage === '') {
        setModalInfo(state => ({
          ...state, title: getResource('Js_MessageError_TitleSuccess'),
          message: response.Results
        }))
        getVendorBills(localStorage.getItem('QuickBooksAuthorizationCode') || '')
      }
      else if ([401, 403].includes(response.httpStatusCode) && response.Message !== '') {
        setModalInfo(state => ({
          ...state, title: getResource('Js_MessageError_TitleSubmit'),
          message: response.Message
        }))
      }
      else {
        setModalInfo(state => ({
          ...state, title: getResource('Js_MessageError_TitleSubmit'),
          message: getResource('SomethingWentWrong')
        }))
      }
    }
    callImport();
  }

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: QBBeneficiary[]) => {
      setSelectedBenes(selectedRows)
    },
    getCheckboxProps: (record: QBBeneficiary) => ({
      disabled: record.BeneficiaryID > 0,
    }),
  };

  const onChangePayBills = () => {
    setPayBills(!payBills)
  }
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: getResource('Label.ImportVendorQuickBooksOnline'),
      onClick: () => {
        setActionSelected('import')
        getVendors(localStorage.getItem('QuickBooksAuthorizationCode') || '')
      }
    },
    {
      key: '2',
      label: getResource('Label.ImportVendorBillsQuickBooksOnline'),
      onClick: () => {
        setActionSelected('importBills')
        getVendorBills(localStorage.getItem('QuickBooksAuthorizationCode') || '')
      }
    }
  ];

  return <div className="row">
    {actionSelected === '' && <>
      <div className="col-md-4 col-xs-12" />
      <div className="col-md-4 col-xs-12" >
        <Dropdown.Button menu={{ items }} style={{ width: '200px' }}>
          <a onClick={e => e.preventDefault()}>
            <Space>
              Select a Option
            </Space>
          </a>
        </Dropdown.Button>
      </div>

    </>}
    {actionSelected === 'import' && <>
      <div className="col-md-12 col-xs-12">
        <Table
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          columns={qbBeneColumns}
          dataSource={benes}
        />
      </div>
      {benes.length > 0 &&
        <div className="row-actions">
          <Button type="primary" disabled={selectedBenes.length === 0} onClick={importQBenes}>{getResource('Label.ImportVendorQuickBooksOnline')}</Button>
          <Button type="secondary" onClick={() => setActionSelected('')}>{getResource('Button.Cancel')}</Button>
        </div>
      }
    </>}
    {
      actionSelected === 'importBills' && <>

        <div className="col-md-12 col-xs-12">
          <Checkbox onChange={onChangePayBills}>Pay Bills</Checkbox>
        </div>
        <div className="col-md-12 col-xs-12">
          <Table
            columns={qbBeneBillsColumns}
            expandable={{
              expandedRowRender: (record) => {
                console.log('record: ', record)
                const columns: TableColumnsType<QBBillDetail> = [
                  { title: '#', dataIndex: 'LineNum', width: '5%', align: 'left' },
                  { title: 'Description', dataIndex: 'Description', width: '30%', align: 'left' },
                  { title: 'Amount', dataIndex: 'Amount', width: '15%', align: 'right' },
                  { title: 'Item', dataIndex: 'ItemName', width: '30%', align: 'right' },
                  { title: 'Unit Price', dataIndex: 'ItemUnitPrice', width: '10%', align: 'right' },
                  { title: 'Qty', dataIndex: 'ItemQty', width: '10%', align: 'right' }
                ];
                let bills: QBBeneBill[] = beneBills.filter((x: QBBeneBill) => x.Id === record.Id);
                let details: QBBillDetail[] = []

                if (Array.isArray(bills)) {
                  details = bills[0].Details
                }
                const data = details
                return <Table columns={columns} dataSource={data} pagination={false} className={"table-details"} />;
              }
            }}
            dataSource={beneBillsDS}
            rowSelection={{
              type: 'checkbox',
              onChange(selectedRowKeys: React.Key[], selectedRows, info) {
                console.log('rowSelection ', selectedRowKeys)
                setSelectedBeneBills(selectedRows)
              },
              getCheckboxProps: (record: QBBeneBill) => ({                
                disabled: (!payBills && (record.BeneficiaryID === 0 || record.InvoiceIssuedId > 0)) || (payBills && record.InvoiceIssuedId === 0),
              }),

            }}
          />
        </div>
        {beneBills.length > 0 && <div className="row-actions">
          {!payBills && <Button type="primary" disabled={selectedBeneBills.length === 0} onClick={importQVendorBills}>{getResource('Label.ImportVendorBillsQuickBooksOnline')}</Button>}
          {payBills && <Button type="primary" disabled={selectedBeneBills.length === 0}>Pay Bills</Button>}
          <Button type="secondary" onClick={() => setActionSelected('')}>{getResource('Button.Cancel')}</Button>
        </div>}
      </>
    }
  </div>;
}

const QuickBooksOnline = () => {

  const { showModal } = useContext(AppContext);

  const [authUrl, setAuthUrl] = useState('')
  const [authState, setAuthState] = useState('')
  const [modalInfo, setModalInfo] = useState({ title: '', message: '' })

  useEffect(() => {
    const id = localStorage.getItem('SessionID') || ''//window.crypto.randomUUID()
    setAuthState(id)
  }, [])

  useEffect(() => {
    const callapi = async () => {

      var response = await getAuthenticationURL(authState);

      let responseStatus = response.httpStatusCode
      let iStatus = responseStatus >= 400 && responseStatus < 500 ? 400 : responseStatus
      switch (iStatus) {
        case 200:
          if (response.ErrorMessage === '') {
            setAuthUrl(response.AuthUrl)
            localStorage.setItem('quickbookonline_state', authState)
          }
          else {
            setModalInfo(state => ({ ...state, title: getResource('Js_MessageError_TitleSubmit'), message: response.Message }));
          }
          break;
        case 400:
        case 401:
        case 402:
        case 403:
          setModalInfo(state => ({
            ...state, title: getResource('Js_MessageError_TitleSubmit'),
            message: response.Message
          }))
          break;
        case (responseStatus >= 500):
          setModalInfo(state => ({ ...state, title: getResource('Js_MessageError_TitleSubmit'), message: getResource('InternalServerError') + response.Message }))
          break;
        default:
          setModalInfo(state => ({ ...state, title: getResource('Js_MessageError_TitleSubmit'), message: getResource('SomethingWentWrong') }));
          break;
      }
    }
    if (authState === '') {
      return;
    }
    callapi()
  }, [authState])

  useEffect(() => {
    if (modalInfo.message === '') {
      return;
    }
    showModal(modalInfo.title, modalInfo.message);
    setModalInfo(state => ({ title: '', message: '' }))
  }, [modalInfo, showModal]);

  const quickBooksAuthorizationCode = localStorage.getItem('QuickBooksAuthorizationCode') || ''
  const logged = quickBooksAuthorizationCode !== ''

  return <>
    {logged ?
      <QBActions authCode={quickBooksAuthorizationCode} /> :
      <div className="row">
        <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '2rem' }}>
          <Button type="primary" onClick={() => window.open(authUrl, "_self", "menubar=0,scrollbars=1,width=780,height=900,top=10")} disabled={authUrl === ''}>Connect to Quickbooks</Button>
        </div>
      </div>}
  </>
}

export default QuickBooksOnline

